export default "__VITE_ASSET__sPW0lPyM__"